import {Component} from '@angular/core';
import {SummaryPlainEntityOrSummaryComponent} from "../../../../../../../common/summary/summary-plain-entity-or-summary/summary-plain-entity-or-summary.component";
import {PaymentRequestReminderSummaryModel} from "../../entity/paymentRequestReminderSummary.model";
import {PaymentRequestReminderModel} from "../../entity/paymentRequestReminder.model";
import {PaymentRequestReminderFindOneByIdService} from "../../service/paymentRequestReminderFindOneById.service";

@Component({
    selector: 'app-payment-request-reminder-summary',
    templateUrl: './payment-request-reminder-summary.component.html',
    providers: [PaymentRequestReminderFindOneByIdService],
})
export class PaymentRequestReminderSummaryComponent extends SummaryPlainEntityOrSummaryComponent<PaymentRequestReminderSummaryModel, PaymentRequestReminderModel> {
    constructor(public findOneService: PaymentRequestReminderFindOneByIdService) {
        super();
    }

    onExpand() {
        if (!this.plain) {
            this.findOneService.loadEntity(this.summary.id)
                .then((result) => this.entity = result);
        }
    }
}
